export const CLEAR_SURVEY = 'CLEAR_SURVEY';
export const NEXT_SCREEN = 'NEXT_SCREEN';
export const PREVIOUS_SCREEN = 'PREVIOUS_SCREEN';
export const FETCH_PROFILE_SURVEY_DATA = 'FETCH_PROFILE_SURVEY_DATA';
export const FETCH_PROFILE_SURVEY_DATA_SUCCESS = 'FETCH_PROFILE_SURVEY_DATA_SUCCESS';
export const FETCH_PROFILE_SURVEY_DATA_FAILURE = 'FETCH_PROFILE_SURVEY_DATA_FAILURE';

export const UPDATE_PROFILE_SURVEY_BASICS_SUCCESS = 'UPDATE_PROFILE_SURVEY_BASICS_SUCCESS';
export const UPDATE_PROFILE_SURVEY_BASICS_FAILURE = 'UPDATE_PROFILE_SURVEY_BASICS_FAILURE';

export const ADD_PROFILE_SURVEY_INTERESTS_SUCCESS = 'ADD_PROFILE_SURVEY_INTERESTS_SUCCESS';
export const ADD_PROFILE_SURVEY_INTERESTS_FAILURE = 'ADD_PROFILE_SURVEY_INTERESTS_FAILURE';

export const DELETE_PROFILE_SURVEY_INTEREST_SUCCESS = 'DELETE_PROFILE_SURVEY_INTEREST_SUCCESS';
export const DELETE_PROFILE_SURVEY_INTEREST_FAILURE = 'DELETE_PROFILE_SURVEY_INTEREST_FAILURE';

export const ADD_PROFILE_SURVEY_CONDITION_SUCCESS = 'ADD_PROFILE_SURVEY_CONDITION_SUCCESS';
export const ADD_PROFILE_SURVEY_CONDITION_FAILURE = 'ADD_PROFILE_SURVEY_CONDITION_FAILURE';

export const DELETE_PROFILE_SURVEY_CONDITION_SUCCESS = 'DELETE_PROFILE_SURVEY_CONDITION_SUCCESS';
export const DELETE_PROFILE_SURVEY_CONDITION_FAILURE = 'DELETE_PROFILE_SURVEY_CONDITION_FAILURE';

export const UPDATE_PROFILE_SURVEY_CONDITION_SUCCESS = 'UPDATE_PROFILE_SURVEY_CONDITION_SUCCESS';
export const UPDATE_PROFILE_SURVEY_CONDITION_FAILURE = 'UPDATE_PROFILE_SURVEY_CONDITION_FAILURE';

export const ADD_PROFILE_SURVEY_TREATMENT_SUCCESS = 'ADD_PROFILE_SURVEY_TREATMENT_SUCCESS';
export const ADD_PROFILE_SURVEY_TREATMENT_FAILURE = 'ADD_PROFILE_SURVEY_TREATMENT_FAILURE';

export const DELETE_PROFILE_SURVEY_TREATMENT_SUCCESS = 'DELETE_PROFILE_SURVEY_TREATMENT_SUCCESS';
export const DELETE_PROFILE_SURVEY_TREATMENT_FAILURE = 'DELETE_PROFILE_SURVEY_TREATMENT_FAILURE';

export const UPDATE_PROFILE_SURVEY_TREATMENT_SUCCESS = 'UPDATE_PROFILE_SURVEY_TREATMENT_SUCCESS';
export const UPDATE_PROFILE_SURVEY_TREATMENT_FAILURE = 'UPDATE_PROFILE_SURVEY_TREATMENT_FAILURE';

export const FETCH_PROFILE_SURVEY_CONDITION_SUGGESTIONS = 'FETCH_PROFILE_SURVEY_CONDITION_SUGGESTIONS';
export const FETCH_PROFILE_SURVEY_CONDITION_SUGGESTIONS_SUCCESS = 'FETCH_PROFILE_SURVEY_CONDITION_SUGGESTIONS_SUCCESS';
export const FETCH_PROFILE_SURVEY_CONDITION_SUGGESTIONS_FAILURE = 'FETCH_PROFILE_SURVEY_CONDITION_SUGGESTIONS_FAILURE';
